<app-loader [show]="isLoading"></app-loader>
<div class="reason-component-container page-root-container page-list-component-container ">
    <div class="page-header">
        <div class="page-title">
            <mat-icon class="icon" style="color: #666; font-size: 24px; width: 24px; height: 24px; margin-right: 8px;">fact_check</mat-icon>
            <span class="title">Reason</span>
        </div>
        <div class="page-actions">
            @if(permission.can_add){
            <button mat-button color="primary" class="btn-add"
                (click)="addClicked()"><mat-icon>add</mat-icon>New</button>
            }
        </div>
    </div>

    <div class="data-container">
        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>
        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef class="item-header" style="width: 50px;">#</th>
                    <td mat-cell *matCellDef="let row; let i = index" class="item-column" style="width: 50px;">
                        {{ (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-sort-header="description" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        Description</th>
                    <td mat-cell *matCellDef="let row" style="font-weight: 500;">{{row.description}}</td>
                </ng-container>

                <ng-container matColumnDef="display_order">
                    <th mat-sort-header="display_order" mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                        style="width: 120px; text-align: center;">Display Order</th>
                    <td mat-cell *matCellDef="let row" style="width: 120px; text-align: center;">
                        <span style="display: inline-block; padding: 2px 10px; background-color: #f1f3f4; border-radius: 4px; font-weight: 600; font-size: 13px;">
                            {{row.display_order ?? 0}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef style="width: 50px;"></th>
                    <td mat-cell class="row-menu-btn" *matCellDef="let rowItem" style="width: 50px; text-align: right;">
                        <a mat-icon-button [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(rowItem);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>
                        <mat-menu #rowMenu>
                            @if(permissionService.getRowPermission(permission,rowItem.id).can_delete){
                            <button mat-menu-item (click)="onDelete(rowItem)">Delete</button>
                            }
                            @if(permissionService.getRowPermission(permission,rowItem.id).can_edit){
                            <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                            }
                            @else{
                            <button mat-menu-item (click)="onEdit(rowItem)">View</button>
                            }
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let row; columns: displayedColumns;"
                    (click)="onRowSelected(row)" (dblclick)="onEdit(row)"
                    [ngClass]="{'row-selected' : row.id===selectedItem?.id}"></tr>
            </table>
        </section>

        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found.</span>
        </div>
        }
    </div>
</div>
